// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompressOutlinedSvg from "@fishx/icons-svg/es/asn/CompressOutlined";
import FishxIcon from '../components/FishxIcon';

var CompressOutlined = function CompressOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CompressOutlinedSvg
  }));
};

CompressOutlined.displayName = 'CompressOutlined';
export default React.forwardRef(CompressOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CompressOutlined.js
// module id = 2299
// module chunks = 0